var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.07895C3 4.77647 4.346 6.1579 6 6.1579C7.654 6.1579 9 4.77647 9 3.07895C9 1.38142 7.654 0 6 0C4.346 0 3 1.38142 3 3.07895ZM11.3333 13H12V12.3158C12 9.67542 9.906 7.52632 7.33333 7.52632H4.66667C2.09333 7.52632 0 9.67542 0 12.3158V13H11.3333Z",
    fill: "url(#paint0_radial_2253_2418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2253_2418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.375 13.4276) rotate(-65.2922) scale(15.2515 26.3511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59139,
    stopColor: "#63E983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41CCCD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.daf81843a441fc8a03a578d0910cefcf.svg";
export { ForwardRef as ReactComponent };